import { combineReducers } from "@reduxjs/toolkit";
import viewDocuments from "./view-documents";

const viewDocumentReducer = combineReducers({
  viewDocuments,
});

export default viewDocumentReducer;
